import { NgModule, ModuleWithProviders } from '@angular/core';
import { FishDropdown, FishDropdownToggle } from './dropdown';
import { FishDropdownConfig } from './dropdown-config';

export { FishDropdown, FishDropdownToggle } from './dropdown';
export { FishDropdownConfig } from './dropdown-config';

const FISH_DROPDOWN_DIRECTIVES = [FishDropdownToggle, FishDropdown];


export class FishDropdownModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishDropdownModule, providers: [FishDropdownConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: FISH_DROPDOWN_DIRECTIVES,
  exports: FISH_DROPDOWN_DIRECTIVES
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
